/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Push_Match_Start_BodyInputs */

const th_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มแข่งแล้วที่ ${i?.event}`)
};

const en_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tip-off now at ${i?.event}`)
};

const ja_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} で試合開始`)
};

const zh_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 现在开球`)
};

const es_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza ahora en ${i?.event}`)
};

const pt_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa agora em ${i?.event}`)
};

const id_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tip-off sekarang di ${i?.event}`)
};

const fr_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Coup d’envoi à ${i?.event}`)
};

const tl_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tip-off na sa ${i?.event}`)
};

const vi_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bóng lên rổ ngay bây giờ tại ${i?.event}`)
};

const ko_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}에서 지금 경기 시작`)
};

const de_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anwurf jetzt bei ${i?.event}`)
};

const ru_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Матч начинается на ${i?.event}`)
};

const tr_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} etkinliğinde maç başlıyor`)
};

const it_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palla a due ora a ${i?.event}`)
};

const pl_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Początek meczu na ${i?.event}`)
};

const uk_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Матч починається на ${i?.event}`)
};

const hi_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} में अभी मैच शुरू`)
};

const ar_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تبدأ المباراة الآن في ${i?.event}`)
};

const ms_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perlawanan bermula sekarang di ${i?.event}`)
};

const bn_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}-এ এখনই খেলা শুরু`)
};

const zh_tw2_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 現在開賽`)
};

const zh_hk2_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 現在開賽`)
};

const ur_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} میں ابھی میچ شروع`)
};

const fa_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آغاز بازی هم‌اکنون در ${i?.event}`)
};

const sw_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mchezo unaanza sasa ${i?.event}`)
};

const nl_push_match_start_body = /** @type {(inputs: Push_Match_Start_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nu begonnen bij ${i?.event}`)
};

/**
* | output |
* | --- |
* | "Tip-off now at {event}" |
*
* @param {Push_Match_Start_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_match_start_body = /** @type {((inputs: Push_Match_Start_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Match_Start_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_match_start_body(inputs)
	if (locale === "ja") return ja_push_match_start_body(inputs)
	if (locale === "zh") return zh_push_match_start_body(inputs)
	if (locale === "es") return es_push_match_start_body(inputs)
	if (locale === "pt") return pt_push_match_start_body(inputs)
	if (locale === "id") return id_push_match_start_body(inputs)
	if (locale === "fr") return fr_push_match_start_body(inputs)
	if (locale === "tl") return tl_push_match_start_body(inputs)
	if (locale === "vi") return vi_push_match_start_body(inputs)
	if (locale === "ko") return ko_push_match_start_body(inputs)
	if (locale === "de") return de_push_match_start_body(inputs)
	if (locale === "ru") return ru_push_match_start_body(inputs)
	if (locale === "tr") return tr_push_match_start_body(inputs)
	if (locale === "it") return it_push_match_start_body(inputs)
	if (locale === "pl") return pl_push_match_start_body(inputs)
	if (locale === "uk") return uk_push_match_start_body(inputs)
	if (locale === "hi") return hi_push_match_start_body(inputs)
	if (locale === "ar") return ar_push_match_start_body(inputs)
	if (locale === "ms") return ms_push_match_start_body(inputs)
	if (locale === "bn") return bn_push_match_start_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_match_start_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_match_start_body(inputs)
	if (locale === "ur") return ur_push_match_start_body(inputs)
	if (locale === "fa") return fa_push_match_start_body(inputs)
	if (locale === "sw") return sw_push_match_start_body(inputs)
	if (locale === "nl") return nl_push_match_start_body(inputs)
	return en_push_match_start_body(inputs)
});